import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  CUSTOMER_DELETE_ERROR,
  CUSTOMER_DELETE_LOADING,
  CUSTOMER_DELETE_SUCCESS,
  CUSTOMER_DELETE_RESET
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  deleted: null
};

function error(error) {
  return {type: CUSTOMER_DELETE_ERROR, error};
}

function loading(loading) {
  return {type: CUSTOMER_DELETE_LOADING, loading};
}

function success(deleted) {
  return {type: CUSTOMER_DELETE_SUCCESS, deleted};
}

function reset() {
  return {type: CUSTOMER_DELETE_RESET};
}

const getters = {
  error: state => state.error,
  deleted: state => state.deleted,
  loading: state => state.loading,
};

const actions = {
  delete({ commit }, item) {
    commit(loading(true));
    commit(error(null));
    return http.fetch(item['@id'], {method: 'DELETE'})
      .then(() => {
        commit(loading(false));
        commit(success(item));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(error(e.message));
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [CUSTOMER_DELETE_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [CUSTOMER_DELETE_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [CUSTOMER_DELETE_SUCCESS] (state, payload) {
      state.deleted = payload.deleted;
    },
    [CUSTOMER_DELETE_RESET] (state) {
      state.error = '';
      state.loading = false;
      state.deleted = null;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/delete.js